// a simply fix to workaround js hoisting issues with jquery ui
import jquery from 'jquery';

window.jQuery = jquery;
window.$ = jquery;
window.$.ui = {};
